import { render, staticRenderFns } from "./permission-config.vue?vue&type=template&id=773ba7a8&scoped=true"
import script from "./permission-config.ts?vue&type=script&lang=ts&external"
export * from "./permission-config.ts?vue&type=script&lang=ts&external"
import style0 from "./permission-config.scss?vue&type=style&index=0&id=773ba7a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ba7a8",
  null
  
)

export default component.exports